import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { MusicProvider } from "@/audio/MusicContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Inicio from "@/pages/Inicio";
import NossaHistoria from "@/pages/NossaHistoria";
import CerimoniaRecepcao from "@/pages/CerimoniaRecepcao";
import Padrinhos from "@/pages/Padrinhos";
import ListaPresentes from "@/pages/ListaPresentes";
import ConfirmacaoPresenca from "@/pages/ConfirmacaoPresenca";
import Admin from "@/admin/Admin";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Erro no site:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="grid min-h-screen place-items-center bg-paper px-6 text-center">
          <div className="paper-card gold-frame max-w-md p-10">
            <p className="font-script text-4xl text-ink">Rodrigo &amp; Talita</p>
            <p className="mt-4 font-sans text-sm text-muted">
              Algo deu errado nesta página. Atualize a tela para voltar ao site.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Nav />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <MusicProvider>
          <ScrollManager />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Inicio />} />
              <Route path="/nossa-historia" element={<NossaHistoria />} />
              <Route path="/cerimonia-e-recepcao" element={<CerimoniaRecepcao />} />
              <Route path="/padrinhos" element={<Padrinhos />} />
              <Route path="/lista-de-presentes" element={<ListaPresentes />} />
              <Route path="/confirmacao-presenca" element={<ConfirmacaoPresenca />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </MusicProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
